import { render, staticRenderFns } from "./addMap.vue?vue&type=template&id=1ccf60d8&"
import script from "./addMap.vue?vue&type=script&lang=js&"
export * from "./addMap.vue?vue&type=script&lang=js&"
import style0 from "./addMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports